import { useDetailApi } from "../../../swr/useApi";
import { productService } from "../../api_client";
import type { ProductAttributeLineDto } from "../../../api";

/**
 * Variant axes (Storage, Color, RAM, …) for a product template. Used on the
 * seller's edit page to populate Add-Variant pickers with the existing values
 * plus a "Type new..." option.
 */
export function useProductAttributeLines(productId: number | null | undefined) {
  return useDetailApi<ProductAttributeLineDto[]>({
    key: productId ? `product-attribute-lines-${productId}` : null,
    serviceMethod: async () => await productService.getProductAttributeLines(productId!),
  });
}
